import React from "react";
import { Routes, Route, NavLink, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Inicio from "./pages/aaff/diseños/original/Inicio";
import Comunidades from "./pages/tecnico/ComunidadesServicio";
import Comunidad from "./pages/tecnico/Comunidad";
import CrearHojaVisita from "./pages/tecnico/CrearHojaVisita";
import EditarHojaVisita from "./pages/tecnico/EditarHojaVisita";
import ColaVisitas from "./pages/tecnico/ColaVisitas";
import Proveedores from "./pages/tecnico/Proveedores";
import Proveedor from "./pages/tecnico/Proveedor";
import AAFF from "./pages/tecnico/AAFF";
import AlertasProveedores from "./pages/tecnico/AlertasProveedores";
import DetallesAAFF from "./pages/tecnico/DetallesAAFF";
import Ventas from "./pages/general/Ventas";
import CrearVenta from "./pages/general/CrearVenta";
import DatosPerfil from "../components/perfil/datosPerfil";
import { Boxes, Icon, Building2, Wrench, Warehouse, MapPin, LayoutGrid } from "lucide-react";
import { houses, toolbox } from '@lucide/lab';
import IndicadoresTecnicos from "./pages/admin/IndicadoresTecnicos";
import NoVisitaAlert from "../components/alerts/noVisitaAlert";
import Productos from "./pages/kae/productos/Productos";
import NuevoProducto from "./pages/kae/productos/NuevoProducto";
import EditarProducto from "./pages/kae/productos/EditarProducto";
import Categorias from "./pages/kae/categorias/Categorias";
import NuevaCategoria from "./pages/kae/categorias/NuevaCategoria";
import EditarCategoria from "./pages/kae/categorias/EditarCategoria";
import Instalaciones from "./pages/kae/instalaciones/Instalaciones";
import Instalacion from "./pages/kae/instalaciones/Instalacion";
import Almacenes from "./pages/kae/almacenes/Almacenes";
import Almacen from "./pages/kae/almacenes/Almacen";

export function RouteBundle() {
  return (
    <Routes>
      <Route path="/" element={<Inicio />} />
      <Route path="comunidades" element={<Comunidades />} />
      <Route path="comunidades/:nifFinca" element={<Comunidad />} />
      <Route path="aaff/:nif/comunidades/:nifFinca" element={<Comunidad />} />
      <Route path="hojavisita/:nif/create/:id" element={<CrearHojaVisita />} />
      <Route path="hojavisita/:nif/edit/:id" element={<EditarHojaVisita />} />
      <Route path="hojavisita/:nif/:idCentroTrabajo/create/:id" element={<CrearHojaVisita />} />
      <Route path="hojavisita/:nif/:idCentroTrabajo/edit/:id" element={<EditarHojaVisita />} />
      <Route path="cola-visitas" element={<ColaVisitas />} />
      <Route path="proveedores" element={<Proveedores />} />
      <Route path="proveedores/:nif" element={<Proveedor />} />
      <Route path="aaff" element={<AAFF />} />
      <Route path="aaff/:nif/comunidades" element={<DetallesAAFF />} />
      <Route path="/alertas-proveedores" element={<AlertasProveedores />} />
      <Route path="/alertas-aaff" element={<NoVisitaAlert />} />
      <Route path="/servicios/" element={<Ventas />} />
      <Route path="/servicios/create" element={<CrearVenta />} />
      <Route path="/servicios/edit/:ventaId" element={<EditarHojaVisita />} />
      <Route path="/perfil" element={<DatosPerfil />} />
      <Route path="/productos" element={<Productos />} />
      <Route path="/productos/nuevo" element={<NuevoProducto />} />
      <Route path="/productos/editar/:id" element={<EditarProducto />} />
      <Route path="/categorias" element={<Categorias />} />
      <Route path="/categorias/nueva" element={<NuevaCategoria />} />
      <Route path="/categorias/editar/:id" element={<EditarCategoria />} />
      <Route path="/instalaciones" element={<Instalaciones />} />
      <Route path="/instalaciones/:id" element={<Instalacion />} />
      <Route path="/almacenes" element={<Almacenes />} />
      <Route path="/almacenes/:id" element={<Almacen />} />
      <Route path="/indicadores/tecnicos" element={<IndicadoresTecnicos />} />
      <Route path="*" element={<Navigate to='/' replace />} />
      <Route path="*" element={<Navigate to='/' replace />} />
    </Routes>
  );
}

const refrescoLocal = () => {
  localStorage.setItem("hasReloaded", "true");
}

export function MenuLinksClientes(props) {
  const { t } = useTranslation('nav');
  return (
    <>
      <li>
        <NavLink
          activeclassname="active"
          to="/aaff"
          style={{
            display: props.showSidebar ? "flex" : "block",
            alignItems: props.showSidebar ? "center" : "",
            color: props.showSidebar ? "#33383b" : "#fff",
          }}
        >
          <div className="menuBtn" onClick={refrescoLocal}>
            <Building2 stroke-width="1.5" alt={t('clients.aaff')} />{t('clients.aaff')}
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          activeclassname="active"
          to="/proveedores"
          style={{
            display: props.showSidebar ? "flex" : "block",
            alignItems: props.showSidebar ? "center" : "",
          }}
        >
          <div className="menuBtn" onClick={refrescoLocal}>
            <Wrench stroke-width="1.5" alt={t('clients.suppliers')} />{t('clients.suppliers')}
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          activeclassname="active"
          to="/comunidades"
          style={{
            display: props.showSidebar ? "flex" : "block",
            alignItems: props.showSidebar ? "center" : "",
          }}
        >
          <div className="menuBtn" onClick={refrescoLocal}>
            <Icon iconNode={houses} stroke-width="1.5" alt={t('clients.communities')} />{t('clients.communities')}
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          activeclassname="active"
          to="/servicios"
          style={{
            display: props.showSidebar ? "flex" : "block",
            alignItems: props.showSidebar ? "center" : "",
          }}
        >
          <div className="menuBtn" onClick={refrescoLocal}>
            <Boxes stroke-width="1.5" width="35px" alt={t('clients.services')} />{t('clients.services')}
          </div>
        </NavLink>
      </li>
    </>
  );
}

export function MenuLinks(props) {
  const { t } = useTranslation('nav');
  return (
    <>
      <li>
        <NavLink
          activeclassname="active"
          to="/alertas-aaff"
          style={{
            display: props.showSidebar ? "flex" : "block",
            alignItems: props.showSidebar ? "center" : "",
          }}
        >
          <div className="menuBtn" onClick={refrescoLocal} >
            <Building2 stroke-width="1.5" alt={t('alerts.aaffAlerts')} />{t('alerts.aaffAlerts')}
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          activeclassname="active"
          to="/alertas-proveedores"
          style={{
            display: props.showSidebar ? "flex" : "block",
            alignItems: props.showSidebar ? "center" : "",
          }}
        >
          <div className="menuBtn" onClick={refrescoLocal} >
            <Wrench stroke-width="1.5" alt={t('alerts.supplierAlerts')} />{t('alerts.supplierAlerts')}
          </div>
        </NavLink>
      </li>
    </>
  );
}
export function MenuLinksDashboard(props) {
  return (
    <>
      <li>
        <NavLink activeclassname="active" to="/indicadores/tecnicos" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
          <div className="menuBtn" >
            <Icon iconNode={toolbox} stroke-width="1.5" alt="Técnicos" />Técnicos
          </div>
        </NavLink>
      </li>
    </>
  )
}
export function MenuLinksKae(props) {
  const { t } = useTranslation('nav');
  return (
    <>
        <li>
          <NavLink activeclassname="active" to="/productos" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn" onClick={refrescoLocal} >
              <Boxes stroke-width="1.5" alt={t('kae.products')} />{t('kae.products')}
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink activeclassname="active" to="/categorias" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn" onClick={refrescoLocal} >
              <LayoutGrid stroke-width="1.5" alt={t('kae.categories')} />{t('kae.categories')}
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink activeclassname="active" to="/almacenes" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn" onClick={refrescoLocal} >
              <Warehouse stroke-width="1.5" alt={t('kae.store')} />{t('kae.store')}
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink activeclassname="active" to="/instalaciones" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn" onClick={refrescoLocal} >
              <MapPin stroke-width="1.5" alt={t('kae.installations')} />{t('kae.installations')}
            </div>
          </NavLink>
        </li>
    </>
  )
}